<script lang="ts" setup>
import { useSubscriptionStore } from '@stores/subscription'

import ModalRetryPayment from './ModalRetryPayment.vue'
import ModalRetryProcessing from './ModalRetryProcessing.vue'
import ModalRetrySuccess from './ModalRetrySuccess.vue'

defineOptions({
  name: 'ModalGroupRetryPayment',
})

const subscriptionStore = useSubscriptionStore()
</script>

<template>
  <ModalRetryPayment v-if="subscriptionStore.isModalPaymentRetry" />
  <ModalRetryProcessing v-if="subscriptionStore.isModalPaymentRetryProcessing" />
  <ModalRetrySuccess v-if="subscriptionStore.isModalPaymentRetrySuccess" />
</template>
